export enum CustomEvents {
  SessionId = 'sessionId',
  CookieAcceptance = 'cookieAcceptance',
}
